import React from 'react';
import Lottie from 'lottie-react';


export const LottieAnimation = ({src, style,isloop=true}) => {
    return (
          <Lottie autoplay={true} animationData={src} loop={isloop} style={style} />
    );
};